import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";
import { WidthMode } from "../headerSlice";

interface StyledHeaderProps {
  widthMode?: WidthMode;
}

export default styled.header<StyledHeaderProps>`
  z-index: 2;

  @media screen and (min-width: ${DESKTOP}px) {
    width: ${({ widthMode }) => (widthMode === "full" ? "100%" : "50%")};
  }
`;
